import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-notification-badge',
  templateUrl: './notification-badge.component.html',
  styleUrls: ['./notification-badge.component.css']
})
export class NotificationBadgeComponent implements OnInit {

  @Input("notifyType") notifyType: string;
  @Input("message1") message1: string;
  @Input("message2") message2: string;
  @Output("notificationClick") notifyClicked = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
    if (this.notifyType == undefined) {
      this.notifyType = "notifications_none";
    }
    if (this.message1 == undefined) {
      this.message1 = "Please wait.";
    }
  }

  notificationClick() {
    this.notifyClicked.emit();
  }
}
